import React from 'react';
import HomeBanner from '../../Components/HomeBanner/HomeBanner';
import HomeBody from '../../Components/HomeBody/HomeBody';

const Home = () => {
    return (
      <div>
        <HomeBanner></HomeBanner>
        <HomeBody></HomeBody>
      </div>
    );
};

export default Home;